import React from 'react';
import styled from 'styled-components';
import { Layout } from '../../../../kit/Layout';
import { Text } from '../../../../kit/Text';
import { colors } from '../../../../kit/Theme/Theme';
import {PatchApplicationActivityDto, PatchApplicationDto} from "server-openapi";
import {
    getPatchApplicationDescription
} from "../../../../syncstream/utils/PatchApplicationUtils";
import {UserUtils} from "../../../../syncstream/utils/UserUtils";

export function PatchApplicationCompact(props: { patchApplication: PatchApplicationDto, userUtils: UserUtils }) {
    return (
        <Layout gap={0.5}>
            <PatchObservationContainer gap={0.5} padding={'0.875rem'}>
                <Text style={{ color: colors.bg_orange_600 }} size={'small'} weight={'bold'}>
                    Patch Observations
                </Text>
                {props.patchApplication.activities?.reverse().map((activity, index) => {
                    return <PatchApplicationActivityDetails key={index} patchApplicationActivity={activity} userUtils={props.userUtils} />;
                })}
            </PatchObservationContainer>
        </Layout>
    );
}

function PatchApplicationActivityDetails(props: { patchApplicationActivity: PatchApplicationActivityDto, userUtils: UserUtils }) {
    return (
        <Layout>
            <Text size={'small'} weight={'200'}>
                { getPatchApplicationDescription(props.userUtils, props.patchApplicationActivity?.activityType, props.patchApplicationActivity?.clientUpdatedAt, props.patchApplicationActivity.clientUser) }
                
            </Text>
            {!!props.patchApplicationActivity?.comment && (
                <Text size={'small'} weight={'200'}>
                    Note: {props.patchApplicationActivity.comment}
                </Text>
            )}
        </Layout>
    );
}

const PatchObservationContainer = styled(Layout)`
  border-width: 1px;
  border-style: groove;
`;
